import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/Index.vue'
import NotFound from '../pages/NotFound.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      redirect: '/home',
      component: Index,
      children: [
        {
          path: '/home',
          name: 'Home',
          meta: {
            title: '企业福利助手',
          },
          component: () => import(/* webpackChunkName: "home" */ '../pages/Home.vue')
        },
        {
          path: '/programme',
          name: 'Programme',
          meta: {
            title: '福利方案',
          },
          component: () => import(/* webpackChunkName: "programme" */ '../pages/Programme.vue')
        },
        {
          path: '/about',
          name: 'About',
          meta: {
            title: '关于我们',
          },
          component: () => import(/* webpackChunkName: "about" */ '../pages/About.vue')
        },
      ]
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})

export default router;
